<template>
  <div class="content">

    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote></Freequote>
        </div>
      </div>
    </transition>
    <div class="banane">
      <img src="../assets/images/WechatIMG376.jpeg" />
    </div>
    <div class="main">
      <!-- <div class="carousel">
        <el-carousel indicator-position="outside" height="510px">
          <el-carousel-item v-for="(item,index) in msg" :key="index">
            <img v-lazy="item.imgurl">
          </el-carousel-item>
        </el-carousel>
      </div>-->
    </div>
    <div class="Join">
      <div class="Join-main wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
        <Joinsubmission :kefshow="2"></Joinsubmission>
      </div>
    </div>
    <div class="hot2">
      <!-- <div class="introduce-title">加盟流程</div> -->
      <div class="process wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
        <img src="../assets/images/WechatIMG369.jpeg" oncontextmenu="return false;"/>
      </div>
    </div>
    <div class="hot2">
      <div class="introduce-title wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
        品牌馆
        <!-- <div class="Englishtitle">Brand Hall</div> -->
      </div>
      <div class="process wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2">
        <img src="../assets/images/index/WechatIMG117.jpeg" oncontextmenu="return false;"/>
      </div>
    </div>
    <div>
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import BottomFoot from "../components/BottomFoot.vue";
import Joinsubmission from "../components/Joinsubmission.vue";
import Rightnav from "../components/Rightnav.vue";
import Freequote from "../components/Freequote.vue";
import WOW from "wowjs";
export default {
  components: {
 
    BottomFoot,
    Joinsubmission,
    Rightnav,
    Freequote
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "桔家云整装、整装招商、整装平台、盈利、利润、火爆、最强桔家云整装，由金牌厨柜出品，拥有雄厚的资金实力，以及行业领先的资源、渠道整合能力。一键打通设计、订单、生产、物流、仓储、安装、施工监控等泛家装各环节，为全国装企、设计师、施工队等组织赋能，向消费者提供更全面、更高效、更优质的整体家装解决方案。"
        }
      ]
    };
  },
  data() {
    return {
      nub: "5",
      showquote: false,
      topnub: 0,
      // msg: [
      //   { imgurl: require("../assets/images/WechatIMG128.jpeg"), name: "1" },
      //   { imgurl: require("../assets/images/xgt10005602.jpg"), name: "2" },
      //   { imgurl: require("../assets/images/xgt10005602.jpg"), name: "3" }
      // ],
      jmshow: true
    };
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    }),
      new WOW.WOW().init();
  },
  methods: {
    getshow(data) {
      //console.log("data", data);
      this.showquote = data;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    }
  },
  created: function() {
    const self = this;
  }
};
</script>
<style scoped>
.content {
  width: 100%;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
  margin-top: 93px;
}
.Join-main {
  width: 80%;
  margin: 0 auto;
  /* height: 400px; */
  border-top-right-radius: 100px;
  border-bottom-left-radius: 100px;
  background: #b31d25;
}
.el-carousel__item img {
  width: 100%;
  height: 100%;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.Join {
  margin-top: 2rem;
}
.introduce {
  width: 80%;
  margin: 0 auto;
  margin-top: 60px;
  margin-bottom: 20px;
}
.introduce-main {
  width: 100%;
  height: 300px;
}
.introduce-title {
  font-size: 30px;
  color: #b31d25;
  margin-top: 30px;
  margin-bottom: 30px;
}
.introduce-left {
  width: 49%;
  height: 300px;
  float: left;
  color: rgb(179, 29, 37);
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(221, 221, 221);
  border-image: initial;
}
.introduce-right {
  width: 49%;
  height: 300px;
  float: left;
  color: rgb(179, 29, 37);
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(221, 221, 221);
  border-image: initial;
}
.iconfont {
  font-size: 100px;
}
.introduce-left-img {
  width: 100%;
  height: 300px;
  float: left;
}
.introduce-left-img img {
  width: 100%;
  height: 100%;
}
.introduce-right-img {
  width: 100%;
  height: 300px;
  float: left;
}
.introduce-right-img img {
  width: 100%;
  height: 100%;
}
.introduce-left-text {
  width: 100%;
  text-align: center;
}
p {
  text-align: left;
  margin-block-start: 0em;
  margin-block-end: 0em;
  color: rgb(153, 153, 153);
  line-height: 29px;
  font-size: 14px;
}
.hot2 {
  width: 100%;
  margin-top: 5rem;
}
.process {
  width: 100%;
  overflow: hidden;
}
.process img {
  width: 90%;
  height: 100%;
}
.el-button--default {
  width: 100%;
  background: #b31d25;
  border: 0px;
  color: #fff;
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.banane {
  width: 100%;
  height: 340px;
  
}
.banane img {
  width: 100%;
  height: 100%;
}
</style>
